"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=UserSchool.js.map